<template>
  <ol class='breadcrumb pl-4 mb-2'>
    <li class='breadcrumb-item' :key='index' v-for='(routeObject, index) in routeRecords'>
      <span class='active' v-if='isLast(index)'>{{ getName(routeObject) }}</span>
      <router-link :to='routeObject' v-else>{{ getName(routeObject) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getName (item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null
    },
    isLast (index) {
      return index === this.list.length - 1
    }
  },
  computed: {
    routeRecords: function () {
      return this.list.filter((route) => route.name || route.meta.label)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue